import { action, makeObservable, observable, runInAction } from 'mobx'

import { adaptSocialMediaErrors } from 'shared/adapters/settings'
import { getSocialMedia, saveSocialMedia } from 'shared/api/settings'
import { processApiError } from 'shared/api/utils'
import { LoadableStore } from 'shared/stores'

class SocialMediaSettingsStore {
  parent

  @observable loading = new LoadableStore()
  @observable isSaving = false
  @observable errors

  @observable facebook
  @observable instagram
  @observable website

  constructor (parent) {
    makeObservable(this)
    this.parent = parent
  }

  @action.bound
  fetch () {
    this.loading.setLoading()
    return getSocialMedia().then(response => {
      runInAction(() => {
        Object.assign(this, response.data)
        this.loading.setLoaded()
      })
    })
  }

  @action.bound
  save (data) {
    this.isSaving = true
    return saveSocialMedia(data)
      .then(response => {
        runInAction(() => {
          Object.assign(this, response.data)
        })
      })
      .catch(error => {
        runInAction(() => {
          this.errors = processApiError(error, adaptSocialMediaErrors)
        })
        throw error
      })
      .finally(() => {
        runInAction(() => {
          this.isSaving = false
        })
      })
  }
}

export default SocialMediaSettingsStore
